function monkeyPatchFetch() {
    const {fetch: origFetch} = window;
    window.fetch = async (input, init) => {

        return await origFetch(input, init);
    };
}

export const initAnalytics = async () => {
    const terminalId = localStorage.getItem("terminalId", null)
    let uptimeInSeconds = 0;

    if (!terminalId) {
        alert("ID терминала не найден, перезапустите браузер с очисткой кэша и авторизуйтесь заново");
        return;
    }

    monkeyPatchFetch();

    setInterval(() => {
        const {usedJSHeapSize} = performance.memory;
        const usedJSHeapSizeInMb = usedJSHeapSize / 1_000_000;
        uptimeInSeconds += 1;

        if (usedJSHeapSizeInMb > 200 && uptimeInSeconds > 60 * 10) {
            window.location.reload();
        }
    }, 1000);
};
